import rebuildNavigation from './service/rebuild-navigation.js'

window.OC.Settings = window.OC.Settings || {}
window.OC.Settings.Apps = window.OC.Settings.Apps || {
	rebuildNavigation,
}
